import { applyMiddleware, legacy_createStore as createStore, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import thunkMiddleware from 'redux-thunk'
import { createReduxHistoryContext } from 'redux-first-history'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createBrowserHistory } from 'history'
import { allSagas, injectSaga } from './sagas'
import loggerMiddleware from './middleware/logger'
import sca from './middleware/sca'
import globals from './middleware/globals'
import callback from './middleware/callback'
import monitorReducerEnhancer from './enhancers/monitorReducers'
import createReducer from './reducers'

const immutableStateInvariantMiddleware = require('redux-immutable-state-invariant').default()
const basename = process.env.PUBLIC_URL || ''
export const { routerMiddleware, createReduxHistory, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory({ basename }),
  savePreviousLocations: 1
})

const composeEnhancers = composeWithDevTools({
  trace: true,
  serialize: {
    options: {
      undefined: true,
      function (fn) {
        return fn.toString()
      }
    }
  }
})
const sagaMiddleware = createSagaMiddleware()

const rootStore = (initialState = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================

  const middlewares = [globals, sagaMiddleware, thunkMiddleware, routerMiddleware, sca, callback]

  if (process.env.GTM_ID) {
    const { analytics } = require('Store/middleware/analytics')
    middlewares.push(analytics)
  }
  if (process.env.HAS_SESSION_TIMER === 'true' && process.env.ISMOCK === 'false') {
    const { sessionTimer } = require('Store/middleware/sessionTimer')
    middlewares.push(sessionTimer)
  }
  if (process.env.NODE_ENV !== 'production' && process.env.DEBUG_MODE === 'true') {
    middlewares.push(loggerMiddleware)
  }
  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(immutableStateInvariantMiddleware)
  }

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [applyMiddleware(...middlewares)]
  if (process.env.DEBUG_MODE === 'true') {
    enhancers.push(monitorReducerEnhancer)
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    createReducer(),
    initialState,
    process.env.NODE_ENV === 'development' ? composeEnhancers(...enhancers) : compose(...enhancers)
  )

  store.asyncReducers = {}
  store.injectedSagas = {}
  store.runSaga = sagaMiddleware.run

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer(store.asyncReducers))
    })
  }

  allSagas.forEach((sagas) => {
    injectSaga(store, { key: sagas.key, asyncSaga: sagas.value })
  })

  if (document.readyState === 'complete') {
    setTimeout(() => {
      store.dispatch({
        type: 'REFRESH_PAGE',
        payload: {
          location: { pathname: window.location.pathname }
        }
      })
    }, 200)
  } else {
    window.addEventListener('load', () => {
      setTimeout(() => {
        store.dispatch({
          type: 'REFRESH_PAGE',
          payload: {
            location: { pathname: window.location.pathname }
          }
        })
      }, 200)
    }, { once: true })
  }

  return store
}

export default rootStore()
